import { CheckMarkIconTwoTone, Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { IAgencyAttributes } from 'shared/interfaces/IAgency';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';

import { getFormalDateShort } from 'shared/utils/dateUtils';
import { Left, MainContainer, Right, TextSwitchColor, TextGreyColor } from './ProjectDetails.styles';

interface Props {
  data: ICastingRoleAttributes | undefined;
  dateSubmitted: Date | null | undefined;
  agency: IAgencyAttributes | undefined;
}

const ProjectDetails: React.FC<Props> = ({ data, dateSubmitted, agency }) => {
  return (
    <MainContainer>
      <Left>
        <CheckMarkIconTwoTone />
        <TextSwitchColor size={14}>Submitted</TextSwitchColor>
        <TextGreyColor size={12}>{dateSubmitted ? getFormalDateShort(new Date(dateSubmitted)) : '–'}</TextGreyColor>
      </Left>
      <Right>
        <TextSwitchColor size={16}>{data?.project.name || '–'}</TextSwitchColor>
        <TextGreyColor size={14}>{data?.name || '–'}</TextGreyColor>
        <Typography fontSize={14} color="primary">
          {agency && agency?.name ? (
            <Typography color="primary" fontSize={14}>
              {agency.name}
            </Typography>
          ) : (
            <Typography style={{ color: '#a759ff' }} fontSize={14}>
              Non Represented
            </Typography>
          )}
        </Typography>
      </Right>
    </MainContainer>
  );
};

export default ProjectDetails;
